// ActionRequiredTableHeader.tsx
import { FC } from "react";
import { ACTION_REQUIRED } from "src/constants/todos";

const ActionRequiredTableHeader: FC = () => (
  <thead className="sticky-top z-1">
    {/* <tr>
      <th colSpan={7}></th>
      <th className="colspan-head text-center" colSpan={2}>
        Medical Coverage (Buy & Bill) <span className="border"></span>
      </th>
      <th className="colspan-head text-center" colSpan={2}>
        Pharmacy Coverage (Speciality Pharmacy) <span className="border"></span>
      </th>
    </tr> */}
    <tr className="text-center align-items-center">
      {ACTION_REQUIRED.map((tableHeader, index) => (
        <th
          key={index}
          // className={
          //   index === 7 || index === 9
          //     ? "colspan-head text-center"
          //     : index === 10
          //     ? "colspan-head text-center"
          //     : ""
          // }
        >
          {tableHeader.label}
        </th>
      ))}
    </tr>
  </thead>
);

export default ActionRequiredTableHeader;
